import * as React from "react";
import { Header, Label, Icon } from "semantic-ui-react";
import RecordCard from "./RecordCard";

type LotaProdColumnProps = {
  lotaProd: State.ColumnState;
  approval: State.ApprovalState;
};

class LotaProdColumn extends React.Component<LotaProdColumnProps> {
  private renderApprovalStatus(): JSX.Element | null {
    const { approval } = this.props;

    if (approval.status === "none") {
      return null;
    }

    let color: "yellow" | "green" | "red" = "yellow";
    let icon: "clock outline" | "check circle" | "times circle" = "clock outline";
    let text = "Pending approval";

    if (approval.status === "approved") {
      color = "green";
      icon = "check circle";
      text = "Approved";
    } else if (approval.status === "rejected") {
      color = "red";
      icon = "times circle";
      text = `Rejected${approval.rejectionReason ? `: ${approval.rejectionReason}` : ""}`;
    }

    return (
      <div style={{ marginBottom: "1em" }}>
        <Label color={color} size="large">
          <Icon name={icon} /> {text}
        </Label>
        {approval.requestedBy && (
          <p style={{ marginTop: "0.5em", fontSize: "0.9em", color: "#666" }}>
            Requested by: {approval.requestedBy}
            {approval.requestedAt && (
              <> at {new Date(approval.requestedAt).toLocaleString()}</>
            )}
          </p>
        )}
      </div>
    );
  }

  render(): JSX.Element {
    const { lotaProd } = this.props;

    return (
      <div>
        <Header as="h3" dividing>
          LOTA Prod
        </Header>
        {this.renderApprovalStatus()}
        <RecordCard
          record={lotaProd.record}
          viewJson={lotaProd.viewJson}
          isFetching={lotaProd.isFetching}
          fetchError={lotaProd.fetchError}
          title="Current LOTA Record"
        />
      </div>
    );
  }
}

export default LotaProdColumn;
